import React, { useState, useContext } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import "../styles/Header.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faBoxOpen, faShoppingCart, faUser, faSearch } from "@fortawesome/free-solid-svg-icons";

function Header({ loggedIn }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { cartItems } = useContext(CartContext);
  const cartCount = cartItems.reduce( (total, item) => total + (item.quantity || 1), 0 ); // Default quantity to 1 if not specified

  const navigate = useNavigate();
  const location = useLocation();

  const handleSearch = () => {
    if (searchTerm.trim() === "") return;

    const currentParams = new URLSearchParams(location.search);
    const category = currentParams.get("category");

    // Keep category if present
    const searchURL = category
      ? `/products?category=${category}&search=${encodeURIComponent(searchTerm.trim())}`
      : `/products?search=${encodeURIComponent(searchTerm.trim())}`;

    navigate(searchURL);
    setSearchTerm("");
    setMenuOpen(false);
  };

  return (
    <header className="header">
      {/* Left - Logo */}
      <div
        className="logo"
        onClick={() => navigate("/home")}
        style={{ cursor: "pointer" }}
      >
        ShopSphere
      </div>

      {/* Center - Search Bar */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search for products..."
          value={searchTerm}
          onChange={(e) => {
            const value = e.target.value;
            setSearchTerm(value);
            if (location.pathname.includes("/products")) {
              navigate(`/products?search=${encodeURIComponent(value)}`);
            }
          }}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        />
        <button onClick={handleSearch}>
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>

      {/* Hamburger for mobile */}
      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Right - Nav */}
      <div className={`header-right ${menuOpen ? "active" : ""}`}>
        <NavLink
          to="/home"
          className={({ isActive }) =>
            isActive ? "nav-element active" : "nav-element"
          }
          onClick={() => setMenuOpen(false)}
        >
          <span className="nav-icon">
            <FontAwesomeIcon icon={faHome} />
          </span>
          <span className="nav-text">Home</span>
        </NavLink>

        <NavLink
          to="/products"
          className={({ isActive }) =>
            isActive ? "nav-element active" : "nav-element"
          }
          onClick={() => setMenuOpen(false)}
        >
          <span className="nav-icon">
            <FontAwesomeIcon icon={faBoxOpen} />
          </span>
          <span className="nav-text">Products</span>
        </NavLink>

        <NavLink
          to="/cart"
          className={({ isActive }) =>
            isActive ? "nav-element active" : "nav-element"
          }
          onClick={() => setMenuOpen(false)}
        >
          <span className="nav-icon">
            <FontAwesomeIcon icon={faShoppingCart} />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </span>
          <span className="nav-text">Cart</span>
        </NavLink>

        {loggedIn ? (
          <NavLink
            to="/account"
            className={({ isActive }) =>
              isActive ? "nav-element active" : "nav-element"
            }
            onClick={() => setMenuOpen(false)}
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon={faUser} />
            </span>
            <span className="nav-text">Account</span>
          </NavLink>
        ) : (
          <NavLink
            to="/login"
            className={({ isActive }) =>
              isActive ? "nav-element active" : "nav-element"
            }
            onClick={() => setMenuOpen(false)}
          >
            <span className="nav-icon">
              <FontAwesomeIcon icon={faUser} />
            </span>
            <span className="nav-text">Login/Signup</span>
          </NavLink>
        )}
      </div>
    </header>
  );
}

export default Header;